import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IMenuStore} from "data/stores/menu/menu.store";

export interface IMenuToggleController extends ViewController {
	readonly i18n: ILocalizationStore;
	get isOpen(): boolean;

	toggleOpen: () => void;
}

@injectable()
export class MenuToggleController implements IMenuToggleController {
	get isOpen() {
		return this._menuStore.isOpen;
	}
	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.MenuStore) public _menuStore: IMenuStore
	) {
		makeAutoObservable(this);
	}

	toggleOpen = () => {
		this._menuStore.toggleOpen();
	};
}
